import { jeepRallyApi } from "../api";

const inspectionsBaseUrl = "/api/v1/inspections";
const rallyBaseUrl = "/api/v1/rally";

export const getInspectionByRegistrationId = (registrationId) => {
  return jeepRallyApi.get(
    `${inspectionsBaseUrl}/registration/${registrationId}`
  );
};

export const getRallyInspections = (eventId) => {
  return jeepRallyApi.get(`${rallyBaseUrl}/${eventId}/inspections`);
};

export const createInspection = (payload) => {
  return jeepRallyApi.post(inspectionsBaseUrl, payload);
};

export const updateInspection = (id, payload) => {
  return jeepRallyApi.patch(`${inspectionsBaseUrl}/${id}`, payload);
};
